import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '../../static/icons/filter_icon.svg'


const _hoisted_1 = { class: "listing-facets" }
const _hoisted_2 = { class: "listing-facets__filters" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "listing-facets__show-all-facet-icon",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "listing-facets__filter-text" }
const _hoisted_5 = {
  key: 0,
  class: "listing-facets__active-facets"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "listing-facets__line" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "listing-facets__number-of-products"
}
const _hoisted_8 = { class: "listing-facets__sort" }

import { computed, ref, watch } from 'vue';

import { getContext } from '@/composables/useDynamicProductListing';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

import DrawerLayer from '../DrawerLayer.vue';
import FacetDrawer from './FacetDrawer.vue';
import Sort from '../PLP/Sort.vue';


import { defineComponent } from 'vue';

// For some reason, we have to register dynamic components using the non-setup tag
// or they won't be found.
import FacetButtons from './FacetButtons';

const __default__ = defineComponent({
  components: {
    ...FacetButtons,
  },
});

// the empty script block below makes the tooling not break in the next script block

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ListingFacets',
  setup(__props) {

const {
  activeFacets,
  isFacetsDrawerOpen,
  showDrawerBackButton,
  isMobile,
  productCount,
  toggleElementAnimation,
  openFacetDrawer,
} = getContext();
const { websiteText } = useWebsiteTexts();

const drawerEl = ref<InstanceType<typeof DrawerLayer> | null>(null);

const numberOfActiveFacets = computed(() => {
  return activeFacets.reduce((sum, facet) => (sum += facet.values.length), 0);
});

watch(isFacetsDrawerOpen, () => {
  if (isFacetsDrawerOpen.value) {
    toggleElementAnimation(
      'listing-facets__slide-up',
      drawerEl.value?.$refs?.container as HTMLDivElement
    );
  }
});

function updateDrawerState(isOpen: boolean) {
  toggleElementAnimation(
    'listing-facets__slide-down',
    drawerEl.value?.$refs?.container as HTMLDivElement
  );
  const timeOut = isMobile.value ? 500 : 0;
  setTimeout(() => {
    isFacetsDrawerOpen.value = isOpen;
  }, timeOut);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "listing-facets__show-all-facet clean-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openFacetDrawer)()))
        }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(websiteText)('category__facets_filter').value), 1),
          (_unref(numberOfActiveFacets))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(numberOfActiveFacets)), 1))
            : _createCommentVNode("", true)
        ]),
        _hoisted_6,
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(productCount)), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(Sort)
      ])
    ]),
    _createVNode(DrawerLayer, {
      "onUpdate:modelValue": updateDrawerState,
      modelValue: _unref(isFacetsDrawerOpen),
      showCloseIcon: false,
      modalClass: "listing-facets__drawer",
      ref_key: "drawerEl",
      ref: drawerEl
    }, {
      default: _withCtx(() => [
        _createVNode(FacetDrawer, {
          showBackButton: _unref(showDrawerBackButton),
          "drawer-el": drawerEl.value
        }, null, 8, ["showBackButton", "drawer-el"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})